import script from "./recruitment.vue?vue&type=script&lang=ts&setup=true"
export * from "./recruitment.vue?vue&type=script&lang=ts&setup=true"

import "./recruitment.vue?vue&type=style&index=0&id=f5b97a70&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5b97a70"]])

export default __exports__